// src/services/sugarMeasurementService.js
import axios from 'axios';
import { authHeader } from '../helpers/auth-header';
import api from './api';


export const sugarMeasurementService = {
  getMeasurements,
  getMeasurementsByUserId,
};

async function getMeasurements() {
  try {
    const response = await api.get(`/sugar-measurements`, {
      headers: authHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching measurements:', error);
    throw error;
  }
}

async function getMeasurementsByUserId(userId) {
  try {
    const response = await api.get(`/measurements/user/${userId}`, {
      headers: authHeader()
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching measurements for user ${userId}:`, error);
    throw error;
  }
}

// Other functions remain the same...